export default __webpack_public_path__ + "static/media/portefeuille.bd56469f.svg";